import React, { FC, useCallback } from 'react';
import { OperatorProps } from '../../../../@types/TemplateOperators';
import { ArgsSelect } from './BasicComponents';
import { getColumnDropDownOptions, validateColumnInitValue } from './utils';

const Column: FC<OperatorProps> = ({ step, handleArgsChange, dropDownOptions }) => {
  const [columnNumber] = step.args;

  const options = getColumnDropDownOptions(dropDownOptions);
  const columnInitialValue = validateColumnInitValue(columnNumber, options.length);

  const columnValueHandler = useCallback(
    (value: number | string): void => {
      handleArgsChange([value]);
    },
    [handleArgsChange]
  );

  return (
    <div className="flex mt-6 w-1/2">
      <ArgsSelect
        argsSelectLabel="column"
        options={options}
        onChange={columnValueHandler}
        value={columnInitialValue}
        label="Column number from the input file"
      />
    </div>
  );
};

export default Column;
